import { BaseModal } from '@theme/component-modal';

/**
 * @class VideoPlayerModal
 * @extends BaseModal
 */
class VideoPlayerModal extends BaseModal {
  get shouldAppendToBody() {
    return true;
  }

  get persistAtBody() {
    return true;
  }

  get #videoPlayer() {
    return this.querySelector("video-player");
  }

  onClose() {
    this.#videoPlayer?.pause();
  }
}

if (!customElements.get("video-player-modal")) {
  customElements.define("video-player-modal", VideoPlayerModal);
}
